import React, { useMemo, useState } from "react";

import RowActions from "./row-actions";
import { formatPercent } from "../../helpers/commissionFormat";

const SalesRepRatesTable = ({ salesReps, tiers, onUpdate, editingKey, setEditingKey, isSaving }) => {
  const [draftTier, setDraftTier] = useState(null);

  const tiersByNumber = useMemo(
    () => new Map(tiers.map((tier) => [tier.tier, tier])),
    [tiers]
  );

  const keyFor = (userId) => `rep:${userId}`;

  const handleEdit = (rep) => {
    setDraftTier(rep.tier);
    setEditingKey(keyFor(rep.userId));
  };

  const handleCancel = () => {
    setDraftTier(null);
    setEditingKey(null);
  };

  const handleConfirm = async (rep) => {
    if (draftTier === rep.tier) {
      handleCancel();
      return;
    }

    if (await onUpdate(rep.userId, draftTier)) {
      handleCancel();
    }
  };

  return (
    <div className="commissions-table" data-testid="commission-sales-reps-table">
      <div className="commissions-table-header">
        <h3>Sales Rep Payout Rates</h3>
      </div>
      <table>
        <thead>
          <tr>
            <th>Rep</th>
            <th>Tier</th>
            <th>New</th>
            <th>Repeat</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {salesReps.length === 0 && (
            <tr>
              <td colSpan={5} className="commissions-empty">
                No sales reps have been added
              </td>
            </tr>
          )}
          {salesReps.map((rep) => {
            const isEditing = editingKey === keyFor(rep.userId);
            const selectedTier = isEditing ? draftTier : rep.tier;
            const rates = tiersByNumber.get(selectedTier);

            return (
              <tr key={rep.userId} className={isEditing ? "commissions-row-editing" : undefined}>
                <td>{rep.name}</td>
                <td>
                  <select
                    name="tier"
                    className="commissions-select"
                    value={selectedTier}
                    disabled={!isEditing}
                    onChange={(e) => setDraftTier(Number(e.target.value))}
                  >
                    {tiers.map(({ tier }) => (
                      <option key={tier} value={tier}>
                        {`Tier ${tier}`}
                      </option>
                    ))}
                  </select>
                </td>
                <td>{rates ? formatPercent(rates.newRate) : "-"}</td>
                <td>{rates ? formatPercent(rates.repeatRate) : "-"}</td>
                <td className="commissions-actions">
                  <RowActions
                    isEditing={isEditing}
                    isEditDisabled={editingKey !== null}
                    isSaving={isSaving}
                    onEdit={() => handleEdit(rep)}
                    onConfirm={() => handleConfirm(rep)}
                    onCancel={handleCancel}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SalesRepRatesTable;
